<div class="position-relative z-2 d-flex align-items-center">
  @if (configuration().includeArrows && dateValues()?.startDate && dateValues()?.endDate) {
    <a [class.disabled]="formControlStatus() === 'DISABLED'" class="backward" (click)="adjustDate(-1)">
      <mat-icon>navigate_before</mat-icon>
    </a>
  }
  <mat-form-field
    [ngClass]="configuration().singleDatePicker ? 'date-picker-form-field-single' : 'date-picker-form-field-range'"
    [class.has-errors]="(isTouched || isFormSubmitted) && formControl().errors"
    [class.buttons-grid-column-2]="!configuration().showRanges"
    [class.buttons-grid-column-3]="configuration().showRanges"
    [class.date-picker-form-field-backward-forward]="formControl().value?.startDate"
    appearance="outline"
    subscriptSizing="dynamic"
  >
    <mat-label *ngIf="configuration().label">{{ configuration().label }}</mat-label>
    <div class="d-flex align-items-center justify-content-between">
      <div [style]="{ flex: 1, position: 'relative' }">
        <input
          matInput
          ngxDaterangepickerMd
          type="text"
          [ngModel]="dateValues()"
          [locale]="{
            format: userDateFormat(),
            firstDay: firstDayOfWeekIndex,
            clearLabel: 'button.clear' | translate,
            applyLabel: 'button.apply' | translate,
            cancelLabel: 'button.cancel' | translate,
          }"
          [singleDatePicker]="!!configuration().singleDatePicker"
          [drops]="resolvedDrops"
          [opens]="configuration().opens!"
          [ranges]="configuration().showRanges ? rangesBasedOnConfiguration() : {}"
          [autoApply]="!!configuration().singleDatePicker"
          [closeOnAutoApply]="!!configuration().singleDatePicker"
          [timePicker]="!!configuration().isTimePickerShown"
          [timePicker24Hour]="true"
          [showCancel]="true"
          [alwaysShowCalendars]="true"
          [keepCalendarOpeningWithRange]="true"
          [showClearButton]="configuration().showClearButton!"
          [disabled]="formControlStatus() === 'DISABLED'"
          [minDate]="minDate()"
          [style]="{ display: predefinedEquivalentIfAny() ? 'none' : null }"
          (ngModelChange)="onDatesUpdated($event)"
          (clearClicked)="clearDates()"
          readonly
        />
        @if (!predefinedEquivalentIfAny()) {
          <a class="ngx-daterangepicker-action daterangepicker-trigger-container" (click)="openDatepicker()"></a>
        } @else {
          <input matInput readonly [value]="predefinedEquivalentIfAny()" (click)="openDatepicker(true)" />
        }
      </div>

      @if (configuration().showClearButton && formControl().value?.startDate) {
        <div [style]="{ flex: 0 }" (click)="clearDates(false)">
          <mat-icon [style]="{ zoom: '60%' }" class="material-icons-outlined d-block ps-2 h-100">close </mat-icon>
        </div>
      }
    </div>
  </mat-form-field>
  @if (configuration().includeArrows && dateValues()?.startDate && dateValues()?.endDate) {
    <a [class.disabled]="formControlStatus() === 'DISABLED'" class="forward" (click)="adjustDate(1)">
      <mat-icon>navigate_next</mat-icon>
    </a>
  }
</div>
<div
  *ngIf="configuration().showErrors"
  [class.d-inline-block]="configuration().subscriptSizing === 'fixed' && !isFormControlTouched() && !isFormSubmitted"
>
  <app-custom-mat-error
    *ngIf="isFormControlTouched() || isFormSubmitted"
    [control]="formControl()"
    [isFormSubmitted]="isFormSubmitted"
  ></app-custom-mat-error>
</div>
